var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import './approval-note.css';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import ApprovalNoteAPI from './approval-note-api';
let ApprovalNote = class ApprovalNote extends Component {
    render() {
        const { note, } = this.props;
        return (React.createElement("textarea", { className: "note", value: note, readOnly: true }));
    }
};
ApprovalNote.propTypes = {
    note: string,
};
ApprovalNote = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ApprovalNoteAPI })
], ApprovalNote);
export default ApprovalNote;
//# sourceMappingURL=approval-note.js.map